// Valence -> design tokens. NEVER hardcode hexes here (dark themes must work).
import type { Valence } from "./types";

export const VALENCE_TOKENS: Record<Valence, { tone: string; ghost: string }> = {
  distress: { tone: "var(--color-danger)", ghost: "var(--color-danger-ghost)" },
  resource: { tone: "var(--color-success)", ghost: "var(--color-success-ghost)" },
  neutral: { tone: "var(--color-warning)", ghost: "var(--color-warning-ghost)" },
};

export const EGYEB_TONE = "var(--color-muted)";
